import React from "react";
import { Box, Grid, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: "white",
        px: { xs: 0, md: 6 },
        py: { xs: 0, md: 5 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        borderRadius: "24px",
        width: { xs: "100%", lg: "80%" },
        mx: "auto",
      }}
    >
      <Grid container spacing={{ xs: 3, sm: 8 }} sx={{ width: "90%" }}>
        <Grid item xs={12} sm={6}>
          <Typography
            sx={{
              fontSize: "1rem",
              color: "#666565",
              fontWeight: 500,
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            پشتیبانی پیشرو : 02158117000
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography
            sx={{
              fontSize: "1rem",
              color: "#666565",
              fontWeight: 500,
              textAlign: { xs: "center", sm: "right" },
            }}
          >
            پشتیبانی برلیان : 03131306870
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
